import { useEffect } from "react";
import { useServices } from "@core/servicesContext";
import { SearchDomain } from "@domain/search/searchDomain";
import { useChangeEffect } from "@utils/hooks";

export function useSearchTracking(query: string, domain: SearchDomain): void {
	const { trackingService } = useServices();

	useChangeEffect(() => {
		trackingService.track("search / domain", {
			domain:
				domain === SearchDomain.Course ? "course" : domain === SearchDomain.Organization ? "organization" : "user",
		});
	}, [domain]);

	useEffect(() => {
		trackingService.track("search / query", { query });
	}, [query]);
}
